export const ROLES = {
  ROLE_OWNER: 'ROLE_OWNER',
  ROLE_ADMINISTRATOR: 'ROLE_ADMINISTRATOR',
  ROLE_TECHNICAL: 'ROLE_TECHNICAL',
  ROLE_FINANCE: 'ROLE_FINANCE',
  ROLE_SALES_CS: 'ROLE_SALES_CS',
  ROLE_READ_ONLY: 'ROLE_READ_ONLY',
} as const;

export type RoleType = typeof ROLES[keyof typeof ROLES];

export function hasAnyRole(roles: string[], target: string[]): boolean {
  return roles.some(r => target.includes(r));
}

export function hasOnlyOneOfRoles(roles: string[], targetExclusive: string[]): boolean {
  const intersection = roles.filter(r => targetExclusive.includes(r));
  return intersection.length === 1 && roles.length === 1;
}

